import { IconButton } from '@mui/material'
import { LikeDTO } from '../../models/post'
import ClearIcon from '@mui/icons-material/Clear'
import AvatarEditor from 'react-avatar-editor'
import { useNavigate } from 'react-router-dom'
import { AppRoutes } from '../../helpers/routes'

interface Props {
    likes: LikeDTO[]
    onClose: () => void
}

const LikesModal = ({ likes, onClose }: Props) => {
    const navigate = useNavigate()

    return (
        <div className="flex flex-col w-[60vw] md:w-[25vw] gap-1 md:gap-2">
            <div className="flex items-center">
                <label className="text-secondary font-semibold">Me gusta</label>
                <IconButton
                    onClick={onClose}
                    className="ml-auto p-0 text-primary"
                >
                    <ClearIcon />
                </IconButton>
            </div>
            <div className="flex flex-col gap-1 max-h-48 md:max-h-64 overflow-y-auto">
                {likes.map((like) => (
                    <div
                        key={like.user.email}
                        className="flex flex-col mt-1 md:mt-2 gap-2 md:gap-4 bg-light rounded-[20px] p-2 shadow box-border w-full"
                    >
                        <div className="flex gap-2 md:gap-4 items-center">
                            <div
                                onClick={() =>
                                    navigate(AppRoutes.user.replace(':userId', like.user.id))
                                }
                                className="cursor-pointer"
                            >
                                <AvatarEditor
                                    image={
                                        !!like.user.picture ? like.user.picture : '/adminPhoto.png'
                                    }
                                    height={40}
                                    width={40}
                                    border={0}
                                    className="z-1 rounded-full pointer-events-none"
                                />
                            </div>
                            <span
                                onClick={() =>
                                    navigate(AppRoutes.user.replace(':userId', like.user.id))
                                }
                                className="cursor-pointer hover:underline"
                            >
                                {like.user.firstName + ' ' + like.user.lastName}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default LikesModal
